// extracted by mini-css-extract-plugin
export default {"ebanner":"_h-z"};